import { createMutationHook } from '~/shared/providers/api';

export const useSetDriverDisplayOrderMutation = createMutationHook(
  'transportation.setDriverDisplayOrder',
  (params: { driverId: string; rank: string }) => ({
    transportationSetDriverDisplayOrder: {
      __args: {
        driverId: params.driverId,
        rank: params.rank,
      },
      id: true,
      rank: true,
    },
  }),
);
